export var UserActivityType;
(function (UserActivityType) {
    UserActivityType["LoggedIn"] = "Logged in";
    UserActivityType["LoggedOut"] = "Logged out";
})(UserActivityType || (UserActivityType = {}));
//# sourceMappingURL=userActivityType.enum.js.map